import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { mdiVote } from "@mdi/js";
import Icon from "@mdi/react";
import { cleanJoin } from "../../../../utils/stringUtil";
import { isDesktop } from "../../../../utils/screenUtil";

function ElectionTitle() {
  return (
    <div
      className={cleanJoin(
        isDesktop() ? "is-size-2" : "is-size-4 my-3",
        "is-flex is-align-items-center is-justify-content-center has-text-weight-semibold mx-5"
      )}
    >
      <Trans i18nKey={"voting.elections_title"}>
        <Icon
          path={mdiVote}
          size={isDesktop() ? 2.7 : 1.3}
          className={`has-text-purple-dark mx-4`}
        />
      </Trans>
    </div>
  );
}

export default ElectionTitle;
